import { render, staticRenderFns } from "./dui-toggle-button.vue?vue&type=template&id=abf78d8c&scoped=true&"
import script from "./dui-toggle-button.vue?vue&type=script&lang=js&"
export * from "./dui-toggle-button.vue?vue&type=script&lang=js&"
import style0 from "./dui-toggle-button.vue?vue&type=style&index=0&id=abf78d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf78d8c",
  null
  
)

export default component.exports